import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'

export function useLinkSigningContact(cnpjcpf: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: {
      nome?: string
      document?: string
      contato?: string
      email?: string
      isEmailVerified?: boolean
      isContatoVerified?: boolean
    }) => {
      const response = await api.post(`/clients/${cnpjcpf}/signing-contact`, payload)

      if (!response.data) {
        throw new Error('Erro ao vincular contato adicional')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['client', cnpjcpf] })
    }
  })
}
